import { all, call, put, take } from 'redux-saga/effects';
import { get } from 'lodash';
import { notification } from 'antd';

import { SEND_VERIFY_CODE, CONFIRM_VERIFY_CODE } from '../type';
import {
  sendVerifyCodeErrorAction,
  sendVerifyCodeSuccessAction,
  confirmVerifyCodeErrorAction,
  confirmVerifyCodeSuccessAction,
} from '../action';

import MessengerResource from 'common/resource/MessengerResource';

import { accountService } from 'services';

function* sendVerifyCode() {
  while (1) {
    const action = yield take(SEND_VERIFY_CODE);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        accountService.sendVerifyCode,
        action.payload,
      );
      notification.success({
        message: MessengerResource.verifyCode.sendCodeSuccess,
      });
      callback && callback(response);

      yield put(sendVerifyCodeSuccessAction(response));
    } catch (error) {
      notification.error({
        message: MessengerResource.verifyCode.sendCodeError,
        description: error.message,
      });
      yield put(sendVerifyCodeErrorAction(error));
    }
  }
}

function* confirmVerifyCode() {
  while (1) {
    const action = yield take(CONFIRM_VERIFY_CODE);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        accountService.confirmVerifyCode,
        action.payload,
      );
      callback && callback(response);

      yield put(confirmVerifyCodeSuccessAction(response));
    } catch (error) {
      yield put(confirmVerifyCodeErrorAction(error));
    }
  }
}

export default function* rootSaga() {
  yield all([sendVerifyCode(), confirmVerifyCode()]);
}
